import { render } from "./ModalReturnCase.vue?vue&type=template&id=b4f8059c"
import script from "./ModalReturnCase.vue?vue&type=script&lang=js"
export * from "./ModalReturnCase.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__